<template>
  <div>
    <base-card>
      <v-card-text>
        <div class="forbidden-container text-center py-10">
          <v-icon color="red" size="80">mdi-lock-alert</v-icon>
          <h2 class="mt-4 text-h5 font-weight-bold">Acceso denegado</h2>
          <p class="mt-2">No tienes permiso para acceder a este módulo.</p>

          <v-btn class="mt-4 white--text border-button" color="rgb(204 33 40)" @click="$router.push('/')">
            <v-icon left>mdi-home</v-icon>
            Volver al inicio
          </v-btn>
        </div>
      </v-card-text>
    </base-card>
  </div>
</template>

<script>
export default {
  name: "ForbiddenView",
};
</script>

<style scoped>
.forbidden-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80vh;
}
</style>
